<template>
  <dialog-reset
    custom-class="inout-detail-dialog"
    title="月计划执行详情"
    top="10vh"
    width="80%"
    height="650px"
    visible
    :beforeClose="beforeClose"
  >
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :search.sync="query"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="getCarriageList"
    >
    </avue-crud>
  </dialog-reset>
</template>

<script>
import {getDetailList} from "./api";
import DialogReset from "@/basic-common/components/DialogReset.vue";

export default {
  name: "detailList",
  components: {
    DialogReset,
  },
  props: {
    visible: Boolean,
    row: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      loading: false,
      option: {
        addBtn: false,
        header: false,
        editBtn: false,
        delBtn: false,
        selection: false,
        menu: false,
        align: 'center',
        height: "420",
        column: [
          {
            label: "合同号",
            prop: "contractNo",
          },
          {
            label: "物资名称",
            prop: "cargoName",
            overHidden: true,
          },
          {
            label: "计划名称",
            prop: "planName",
            overHidden: true,
          },
          {
            label: "本日(吨)",
            prop: "todayWeight",
            overHidden: true,
          },
          {
            label: "本周(吨)",
            prop: "thisWeekWeight",
            overHidden: true,
          },
          {
            label: "本月(吨)",
            prop: "thisMonthWeight",
            overHidden: true,
          },
        ],
      },
      query: {},
      data: [],
      showPicture: false,
      selectedRow: {},
      addIndex: 0,
      selectionList: []
    };
  },
  mounted() {
    this.getCarriageList();
  },
  methods: {
    getCarriageList() {
      const {contractNo} = this.row;
      const params = {
        contractNo,
        page: 1,
        size: 999,
      }
      this.loading = true;
      getDetailList(params).then(res => {
        this.data = res.data.data.records
      }).finally(() => {
        this.loading = false;
      })
    },
    searchChange(params, done) {
      this.getCarriageList();
      done();
    },
    searchReset() {
      this.query = {};
      this.getCarriageList();
    },
    beforeClose() {
      this.$emit("update:visible", false);
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .avue-crud__menu {
  display: flex;
}
</style>

<style lang="scss">
.inout-detail-dialog {
  .el-dialog__body {
    max-height: 75vh;
    overflow-y: auto;
  }
}
</style>
